
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 6.662a3 3 0 012.051-2.846l6-2a3 3 0 011.898 0l6 2A3 3 0 0121 6.662V12c0 5.502-5.56 8.842-7.94 10.02a2.376 2.376 0 01-2.12 0C8.56 20.841 3 17.501 3 12V6.662zM15 9a3 3 0 11-6 0 3 3 0 016 0zm-3 5c1.794 0 3.431.675 4.67 1.785a.856.856 0 01.03 1.239l-.184.186c-1.473 1.457-3.246 2.474-4.343 3.017a.377.377 0 01-.346 0c-1.097-.543-2.87-1.56-4.343-3.017a12.118 12.118 0 01-.184-.186.856.856 0 01.03-1.239A6.974 6.974 0 0112 14z"}})])
          )
        }
      }
    